var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingClientDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.828 20.0001C38.828 30.3986 30.3984 38.8281 19.9999 38.8281C9.60146 38.8281 1.17188 30.3986 1.17188 20.0001C1.17188 9.6015 9.60146 1.17199 19.9999 1.17199C30.3984 1.17199 38.828 9.6015 38.828 20.0001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.4688V8.70314",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.5312V31.2969",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7656 12.4688H18.7447C16.6651 12.4688 14.9791 14.1546 14.9791 16.2344C14.9791 18.314 16.6651 19.9999 18.7447 19.9999H21.2552C23.3347 19.9999 25.0207 21.686 25.0207 23.7656C25.0207 25.8453 23.3347 27.5312 21.2552 27.5312H16.2344",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingClientDetail);
export default __webpack_public_path__ + "static/media/pricing-client-detail.5aa2c1ef65016ad3172809370992d922.svg";
export { ForwardRef as ReactComponent };